import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import ProfileDetailTemplate from '../../components/profilemng/ProfileDetailTemplate';
import ProfileTemplate from '../../components/profilemng/ProfileTemplate';
import ApprovalFormContainer from './apprroval/ApprovalFormContainer';
import ApprovalListContainer from './apprroval/ApprovalListContainer';

import ProfiePassContainer from './ProfiePassContainer';
import ProfileFormContainer from './ProfileFormContainer';

const ProfileEditContainer = () => {
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState(null);

  const { user } = useSelector(({ auth, loading }) => ({
    user: auth.user, //user정보
  }));

  useEffect(() => {
    if (user) {
      let title = {
        name: "["+user.usrNo+"] "+user.usrNm + ' ' + user.gradeNm,
        no: user.usrNo,
      };
      setTitleData(title);
    }
  }, [user]);

  const handleGoBack = () => {
    navigate('/profile');
  };

  return (
    <ProfileTemplate user={user}>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="사용자관리/프로필관리/상세보기"
        menuLink="/"
        icon="user"
        titleData={titleData}
      />
      <ProfileDetailTemplate title="기본정보">
      <ProfileFormContainer />
      </ProfileDetailTemplate>
     
      <ProfileDetailTemplate title="비밀번호 변경">
        <ProfiePassContainer />
      </ProfileDetailTemplate>
      
      <ProfileDetailTemplate title="결재선 관리">
        <ApprovalListContainer />
        <ApprovalFormContainer />
      </ProfileDetailTemplate>

    </ProfileTemplate>
  );
};

export default ProfileEditContainer;
